import React from 'react';
import VoxelMenuItem from '../../../../voxel/PopoverMenu/VoxelMenuItem';
import { Option } from './HeadCellRequest';

export interface HeadCellApiCollectionSelectionProps {
  option: Option;
  selectedIds: number[];
  handleFilterChange: (id: number, checked: boolean) => void;
}

const HeadCellApiCollectionSelection: React.FC<HeadCellApiCollectionSelectionProps> = React.memo(
  ({ option, selectedIds, handleFilterChange }) => {
    const selected = selectedIds.some((id) => id === option.apiCallCollection.id);

    return (
      <VoxelMenuItem
        onClick={() => handleFilterChange(option.apiCallCollection.id, !selected)}
        selected={selected}
        title={option.primaryText}
        subtitle={option.secondaryText}
      />
    );
  }
);

export default HeadCellApiCollectionSelection;
